export const KEY_TYPE = {
  ledger: 'ledger',
  wallet: 'wallet',
  readOnly: 'read-only',
  secrets: 'secrets',
};

export const KEY_LIST_TYPE = {
  key: 'key',
  secret: 'secret',
};
